import React, { useEffect, useState } from "react";
import BlurryImage from "./BlurryImage.component";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import AOS from "aos";
import Logo from "../icons/slogo";

import "../styles/content.style.scss";
import "../styles/ventes.style.scss";
import "aos/dist/aos.css";
import { useNavigate, useLocation } from "react-router-dom";

AOS.init();
function Products({ isLoading, products, filter, categorie, listCategorie }) {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    let datas = [...products];
    if (categorie !== "all") {
      datas = datas.filter((p) => {
        return listCategorie[p.categorieProd]?.name === categorie;
      });
    }

    if (filter !== "") {
      datas = datas.filter((p) => {
        return (
          p.nameProd.toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
          p.descriptionProd.toLowerCase().indexOf(filter.toLowerCase()) !== -1
        );
      });
    }
    setItems(datas);
  }, [filter, categorie, products]);

  function handleClickToConctact(e, data) {
    e.preventDefault();
    navigate("/contact", {
      replace: true,
      state: {
        message:
          "Je suis interessé par le produit " +
          data.nameProd +
          " : " +
          data.descriptionProd +
          `\n Lien du produit :${window.location.href}/produit/${data.id}`,
      },
    });
  }
  function handleClickToVoirPlus(e, product, categorie) {
    e.preventDefault();
    const data = { ...product, categorie: categorie };
    navigate(`${location.pathname}/produit/${data.id}`, {
      replace: true,
      state: {
        data,
      },
    });
  }
  return (
    <>
      {items.map((product) => (
        <div className="prod-ctn" key={product.id} data-aos="zoom-in">
          <div className="ctn-img">
            <BlurryImage
              hash={product.imageHashProd}
              className="cover"
              imageUrl={product.imageProd}
            />
          </div>
          <div className="ctn-d">
            <h1 className="title">{product.nameProd}</h1>
            <p className="desc">{product.descriptionProd}</p>
            <h3 className="prix">{product.priceProd} FCFA</h3>
            <span id="categorie">
              {listCategorie[product.categorieProd]?.name}
            </span>
            <div className="ctn-button">
              <button
                className="btn-btn"
                onClick={(e) => handleClickToConctact(e, product)}
              >
                Nous Contactez
              </button>
              <button
                className="btnplus  btn-btn-flat"
                onClick={(e) =>
                  handleClickToVoirPlus(
                    e,
                    product,
                    listCategorie[product.categorieProd]?.name
                  )
                }
              >
                Voir Plus
              </button>
            </div>
          </div>
        </div>
      ))}
      {items.length === 0 && !isLoading && (
        <Logo data-aos="zoom-in" name="searchNotFound" />
      )}
      {isLoading &&
        Array(3)
          .fill(0)
          .map((s, i) => (
            <Box className="prod-ctn">
              <Skeleton
                key={i}
                variant="rectangular"
                height={118}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  margin: "10px 0",
                }}
              />
              <Skeleton
                sx={{
                  width: "30%",
                  borderRadius: "10px",
                }}
              />
              <Skeleton
                sx={{
                  width: "90%",
                  borderRadius: "10px",
                }}
              />
              <Skeleton
                sx={{
                  width: "40%",
                  borderRadius: "10px",
                  height: "40px",
                }}
              />
            </Box>
          ))}
    </>
  );
}
export default Products;

/*products.forEach((product) => {
      if (product.categorie !== categorie && categorie !== "all") {
        return;
      }
      if (
        product.name.toLowerCase().indexOf(filter.toLowerCase()) === -1 &&
        product.description.toLowerCase().indexOf(filter.toLowerCase()) === -1
      ) {
        return;
      }
      items.push(product);
    });*/
/*    */

/*  */
